export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS';
export const SET_ALL_TRANSACTIONS = 'SET_ALL_TRANSACTIONS';
export const SET_RECENT_TRANSACTIONS = 'SET_RECENT_TRANSACTIONS';

export const GET_RECENT_TRANSACTIONS = 'GET_RECENT_TRANSACTIONS';
